module.exports = __webpack_public_path__ + "static/media/Шамсудинов Ф.М., Валиев Р.С..967847ee.pdf";